module.exports = __webpack_public_path__ + "static/media/logo_cropped.26631123.png";